import { render, staticRenderFns } from "./AggiungiCliente.vue?vue&type=template&id=9d75dc24"
import script from "./AggiungiCliente.vue?vue&type=script&lang=js"
export * from "./AggiungiCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports